(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('amazon-statement', {
            parent: 'entity',
            url: '/amazon-statement?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.amazonStatement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/amazon-statement/amazon-statements.html',
                    controller: 'AmazonStatementController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('amazonStatement');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('amazon-statement-detail', {
            parent: 'amazon-statement',
            url: '/amazon-statement/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.amazonStatement.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/amazon-statement/amazon-statement-detail.html',
                    controller: 'AmazonStatementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('amazonStatement');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AmazonStatement', function($stateParams, AmazonStatement) {
                    return AmazonStatement.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'amazon-statement',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('amazon-statement-detail.edit', {
            parent: 'amazon-statement-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/amazon-statement/amazon-statement-dialog.html',
                    controller: 'AmazonStatementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AmazonStatement', function(AmazonStatement) {
                            return AmazonStatement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('amazon-statement.new', {
            parent: 'amazon-statement',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/amazon-statement/amazon-statement-dialog.html',
                    controller: 'AmazonStatementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dtIns: null,
                                gcClaimCode: null,
                                gcId: null,
                                creationRequestId: null,
                                emailSource: null,
                                emailDestination: null,
                                currencyCode: null,
                                amount: null,
                                cardStatus: null,
                                status: null,
                                processed: null,
                                gcExpirationDate: null,
                                operationCode: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('amazon-statement', null, { reload: 'amazon-statement' });
                }, function() {
                    $state.go('amazon-statement');
                });
            }]
        })
        .state('amazon-statement.edit', {
            parent: 'amazon-statement',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/amazon-statement/amazon-statement-dialog.html',
                    controller: 'AmazonStatementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AmazonStatement', function(AmazonStatement) {
                            return AmazonStatement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('amazon-statement', null, { reload: 'amazon-statement' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('amazon-statement.delete', {
            parent: 'amazon-statement',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/amazon-statement/amazon-statement-delete-dialog.html',
                    controller: 'AmazonStatementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AmazonStatement', function(AmazonStatement) {
                            return AmazonStatement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('amazon-statement', null, { reload: 'amazon-statement' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
